import * as React from "react";

var ClientTabs = function ClientTabs(props) {
  var currentType = props.currentType,
      onChangeCurrentType = props.onChangeCurrentType;
  return /*#__PURE__*/React.createElement("ul", {
    className: "nav nav-tabs"
  }, /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link ".concat(currentType === "contratante" ? "active" : ""),
    onClick: function onClick() {
      return onChangeCurrentType("contratante");
    }
  }, "Contratante")), /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link ".concat(currentType === "asegurado" ? "active" : ""),
    onClick: function onClick() {
      return onChangeCurrentType("asegurado");
    }
  }, "Asegurado")), /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link ".concat(currentType === "beneficiario" ? "active" : ""),
    onClick: function onClick() {
      return onChangeCurrentType("beneficiario");
    }
  }, "Beneficiario")));
};

export default ClientTabs;